import React, { useContext, useState } from 'react'
import { Modal, View } from 'oio-react'
import Helmet from 'react-helmet'
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import AccountSettings from 'src/apps/Account/apps/Settings'
import BanUserConfirm from 'src/apps/Account/components/BanUserConfirm'
import { useOrganization, useUser } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import NotFound from 'src/pages/NotFound'
import Collection from '~/Profile/apps/Collection'
import LoginHistory from '~/Profile/apps/LoginHistory'
import AboutBlock from '~/Profile/components/AboutBlock'
import CollectionBlock from '~/Profile/components/CollectionBlock'
import RecentsBlock from '~/Profile/components/RecentsBlock'
import SpaceBlock from '~/Profile/components/SpaceBlock'

const Profile = () => {
   const history = useHistory()
   const { userId } = useParams()
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)
   const [modalIsOpen, setModalIsOpen] = useState(true)

   const { user, error, networkStatus } = useUser({ id: userId })
   const { organization } = useOrganization()
   const initialLoading = networkStatus <= 2

   if (initialLoading) {
      return null
   }

   if (error) {
      return <NotFound />
   }

   return (
      <View
         paddingTop={theme.viewportMarginTop}
         paddingLeft={theme.viewportMarginLeft}
         paddingRight={theme.viewportMarginRight}>
         <Helmet title={user.fullName} />
         <View display="flex[d-f]">
            <View
               flex="0 0 auto"
               float="left"
               width="100%[a-e] calc(((100% - 1700px) / 2) + 550px)[f]"
               maxWidth="380px[d] 500px[e]"
               backgroundColor="#fafafa">
               <View paddingLeft="calc((100% - 1700px) / 2)[f]">
                  <View
                     float="right"
                     width="100%"
                     maxWidth="550px[f]"
                     paddingLeft="18px[a] 9vw[b] 6vw[c] 4vw[d] 100px[e] 200px[f]"
                     paddingRight="18px[a] 9vw[b] 6vw[c] 4vw[d] 60px[e-f]"
                     paddingVertical="60px[a-b] 90px[c] 60px[d] 80px[e-f]">
                     <AboutBlock />
                  </View>
               </View>
            </View>
            <View
               float="left"
               width="
                  100%[a-c]
                  calc(100% - 380px)[d]
                  calc(100% - 500px)[e]
                  calc(((100% - 1700px) / 2) + calc(1700px - 550px))[f]
               "
               minHeight="100vh[d-f]">
               <View
                  maxWidth="calc(1700px - 550px)[f]"
                  paddingLeft="18px[a] 9vw[b] 6vw[c] 4vw[d] 60px[e-f]"
                  paddingRight="0px[a] 9vw[b] 6vw[c] 4vw[d] 100px[e] 200px[f]"
                  paddingVertical="30px[a-b] 50px[c-d] 70px[e-f]">
                  <CollectionBlock />
                  <RecentsBlock />
                  {userId === 'me' && <SpaceBlock />}
                  <Switch>
                     <Route path={`${match.path}/collection/:collectionFilter`}>
                        <Modal
                           borderRadius="5px"
                           width="100%[a] 360px[b] 90%[c] 650px[d-f]"
                           height="100%[a] 80%[b] 90%[c-f]"
                           onCloseComplete={() => {
                              history.push(match.url)
                              setModalIsOpen(true)
                           }}
                           onCloseTrigger={() => setModalIsOpen(false)}
                           open={modalIsOpen}>
                           <Collection onCloseButtonClick={() => setModalIsOpen(false)} />
                        </Modal>
                     </Route>
                     {organization.currentUserCanEdit && (
                        <Route path={`${match.path}/ban-user`}>
                           <Modal
                              borderRadius="6px"
                              width="100%[a-b] 400px[c-f]"
                              maxHeight="100%"
                              onCloseComplete={() => {
                                 history.push(match.url)
                                 setModalIsOpen(true)
                              }}
                              onCloseTrigger={() => setModalIsOpen(false)}
                              open={modalIsOpen}>
                              <BanUserConfirm
                                 onBanComplete={() => window.location.assign('/')}
                                 onCancelButtonClick={() => setModalIsOpen(false)}
                                 userId={userId}
                              />
                           </Modal>
                        </Route>
                     )}
                     {userId === 'me' && (
                        <>
                           <Route path={`${match.path}/settings`}>
                              <Modal
                                 borderRadius="5px"
                                 width="100%[a] 360px[b] 90%[c] 720px[d-f]"
                                 height="100%[a] 80%[b] 540px[c-f]"
                                 onCloseComplete={() => {
                                    history.push(match.url)
                                    setModalIsOpen(true)
                                 }}
                                 onCloseTrigger={() => setModalIsOpen(false)}
                                 open={modalIsOpen}>
                                 <AccountSettings
                                    onCloseButtonClick={() => setModalIsOpen(false)}
                                 />
                              </Modal>
                           </Route>
                           <Route path={`${match.path}/login-history`}>
                              <Modal
                                 borderRadius="5px"
                                 width="100%"
                                 height="100%[a-b] 95%[c-f]"
                                 maxWidth="650px"
                                 onCloseComplete={() => {
                                    history.push(match.url)
                                    setModalIsOpen(true)
                                 }}
                                 onCloseTrigger={() => setModalIsOpen(false)}
                                 open={modalIsOpen}>
                                 <LoginHistory onCloseButtonClick={() => setModalIsOpen(false)} />
                              </Modal>
                           </Route>
                        </>
                     )}
                  </Switch>
               </View>
            </View>
         </View>
      </View>
   )
}

export default Profile
